import React, { useState } from 'react'
import PropTypes from 'prop-types'

import CampaignsItem from '../CampaignsItem'
import { scrollToId } from '../../../herpers/scrollToId'
import { getFormatDate } from '../../../herpers/listCampaigns'
import {
  Pagination
} from './CampaignsList'

const CampaignsList = ({ campaignsList, messageList }) => {
  const [activeState, setActiveState] = useState([])
  const [currentPage, setCurrentPage] = useState(1)
  const itemsPerPage = 10

  const toggleAccordion = (index, campaignId) => {
    let newActiveState = activeState.slice()
    if (activeState[index] === true) {
      newActiveState[index] = !newActiveState[index]
    } else {
      newActiveState = activeState.map((i, idx) => idx === index)
      newActiveState[index] = true
    }

    setActiveState(newActiveState)
    scrollToId('campaignsItem-' + campaignId)
  }

  const totalPages = Math.ceil(campaignsList.length / itemsPerPage)
  const currentData = campaignsList.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  )

  const handlePageChange = (page) => {
    setCurrentPage(page)
  }

  const renderPageNumbers = () => {
    const pageNumbers = []
    const maxVisiblePages = 10
    const halfVisible = Math.floor(maxVisiblePages / 2)

    let startPage = Math.max(1, currentPage - halfVisible)
    let endPage = Math.min(totalPages, currentPage + halfVisible)

    if (endPage - startPage < maxVisiblePages - 1) {
      if (startPage === 1) {
        endPage = Math.min(totalPages, endPage + (maxVisiblePages - (endPage - startPage) - 1))
      } else if (endPage === totalPages) {
        startPage = Math.max(1, startPage - (maxVisiblePages - (endPage - startPage) - 1))
      }
    }

    if (startPage > 1) {
      pageNumbers.push(
        <button key="first" onClick={() => handlePageChange(1)} className="pagination-btn">
          1
        </button>
      )
      if (startPage > 2) {
        pageNumbers.push(<span key="dots-start">...</span>)
      }
    }

    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(
        <button
          key={i}
          onClick={() => handlePageChange(i)}
          className={`pagination-btn ${currentPage === i ? 'active' : ''}`}
        >
          {i}
        </button>
      )
    }

    if (endPage < totalPages) {
      if (endPage < totalPages - 1) {
        pageNumbers.push(<span key="dots-end">...</span>)
      }
      pageNumbers.push(
        <button key="last" onClick={() => handlePageChange(totalPages)} className="pagination-btn">
          {totalPages}
        </button>
      )
    }

    return pageNumbers
  }

  return (
    <div>
      {currentData.map((item, index) => {
        const adsDisplay = item.advertisements || []
        const adsSponsored = item.adSponsoredContents || []
        const totalAds = adsDisplay.concat(adsSponsored)
        const message = messageList?.find(
          (msg) => msg.advertising?.campaign?.campaignId === item.campaignId
        )


        return (
          <CampaignsItem
            key={item.campaignId}
            campaignName={item.name}
            campaignId={item.campaignId}
            buyDate={getFormatDate(item.createdAt)}
            onClick={() => toggleAccordion(index, item.campaignId)}
            active={activeState[index]}
            ads={totalAds}
            advertisementsType={item.advertisements || []}
            adSponsoredContentsType={item.adSponsoredContents || []}
            manualStatus={item.manualStatus}
            materialStatus={item.materialStatus}
            dateStatus={item.dateStatus}
            id={'campaignsItem-' + item.campaignId}
            message={message}
          />
        )
      })}
      {(campaignsList && (campaignsList.length >= 10 || messageList >= 10) ? 
        <Pagination>
        <button
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 1}
          className='pagination-btn-action'
        >
          {'<'}
        </button>
        {renderPageNumbers()}
        <button
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
          className='pagination-btn-action'
        >
          {'>'}
        </button>
      </Pagination> : null)}
    </div>
  )
}

CampaignsList.propTypes = {
  campaignsList: PropTypes.array,
}

export default CampaignsList